import React from 'react';
import PropTypes from 'prop-types';

import {Alert, Button, Stack} from 'views/components';
import {translate} from 'views/module';

import backend from 'utils/backend';

const ClientFeHandoff = (props) => {
  const {clientData, setRefresh} = props;
  const [createdClientRn, setCreatedClientRn] = React.useState(null);
  const [pending, setPending] = React.useState(false);
  const [error, setError] = React.useState(null);
  const inFlight = React.useRef(false);
  const clientRn = clientData.clientFeClientRn || clientData.clientRn || createdClientRn;

  const create = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setPending(true);
    setError(null);
    try {
      const result = await backend.loom.loomLead.handoffClient(clientData.clientId);
      if (!result.clientRn) throw new Error('Missing Client-FE identifier');
      setCreatedClientRn(result.clientRn);
      setRefresh((value) => value + 1);
    } catch (failure) {
      console.error('Client-FE handoff failed', {
        type: failure?.code || failure?.name || 'UNKNOWN',
        status: failure?.status,
      });
      setError(translate('loomLead.LoomLeadDetail.Header.ClientFeHandoff.Error'));
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  };

  if (!clientRn && clientData.status === 'LEAD') return null;

  return (
    <Stack
      spacing={1}
      sx={{
        'alignItems': 'flex-start',
        '& .MuiButton-root': {
          'minWidth': '64px',
          'height': '32px',
          'px': '10px',
          'py': '8px',
          'borderRadius': '7px',
          'backgroundColor': '#DA7955',
          'color': '#FFFFFF',
          'fontStyle': 'normal',
          'fontWeight': 500,
          'fontSize': '12px',
          'lineHeight': '12px',
          'textTransform': 'none',
          'boxShadow': 'none',
          '&:hover': {
            'backgroundColor': '#C96D4B',
            'boxShadow': 'none',
          },
        },
      }}
    >
      {
        clientRn ?
        <Button href={`/client/${encodeURIComponent(clientRn)}`}>
          {translate('loomLead.LoomLeadDetail.Header.ClientFeHandoff.Open')}
        </Button> :
        <Button onClick={create} loading={pending} disabled={pending}>
          {translate(`loomLead.LoomLeadDetail.Header.ClientFeHandoff.${pending ? 'Creating' : 'Create'}`)}
        </Button>
      }
      {
        error &&
        <Alert severity='error'>{error}</Alert>
      }
    </Stack>
  );
};

ClientFeHandoff.propTypes = {
  clientData: PropTypes.object.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(ClientFeHandoff);
